import { breakpoint } from '@/mobile'

function shareButtons(): void {
    resetButtons(breakpoint);

    // Use querySelectorAll and forEach for jQuery-like selection
    document.querySelectorAll('.openShareWindow').forEach((element) => {
        element.addEventListener('click', (event) => {
            const target = event.currentTarget as HTMLElement;
            const docURL = encodeURIComponent(window.location.href);
            const docTitle = encodeURIComponent(document.title);
            const type = target.id;

            let url = 'https://';
            let winName = '';

            switch (type) {
                case 'sTwitter':
                    url += `www.twitter.com/intent/tweet?text=${docTitle}%20-%20${docURL}&via=ErgonAG`;
                    winName = 'Twitter';
                    break;
                case 'sLinkedIn':
                    url += `www.linkedin.com/shareArticle?mini=true&url=${docURL}&title=${docTitle}`;
                    winName = 'LinkedIn';
                    break;
                case 'sXing': { // Added opening brace here
                    const followUrl = encodeURIComponent('https://www.xing.com/companies/ergoninformatikag');
                    url += `www.xing.com/spi/shares/new?url=${docURL}&follow_url=${followUrl}`;
                    winName = 'Xing';
                    break;
                } // Added closing brace here
                case 'sFacebook':
                    url += `www.facebook.com/sharer/sharer.php?u=${docURL}&t=${docURL}`;
                    winName = 'Facebook';
                    break;
            }

            const winSize = 'width=660,height=620,scrollbars=yes';
            window.open(url, winName, winSize);
        });
    });

    document.querySelectorAll('.openMail').forEach((el) => {
        el.addEventListener('click', () => {
            const docURL = encodeURIComponent(window.location.href);
            const docTitle = encodeURIComponent(document.title);
            window.location.href = `mailto:?subject=${docTitle}&body=${docURL}`;
        });
    });

    document.querySelectorAll('.shareWhatsapp').forEach((el) => {
        el.addEventListener('click', () => {
            const docURL = encodeURIComponent(window.location.href);
            const docTitle = encodeURIComponent(document.title);
            window.location.href = `whatsapp://send?text=${docTitle}-${docURL}`;
        });
    });

    window.addEventListener('resize', () => {
        resetButtons(breakpoint);
    });

    // Hover implementation using mouseenter and mouseleave
    const footerShare = document.querySelector('footer > .share');
    if (footerShare) {
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        footerShare.addEventListener('mouseenter', () => {
            if (!isMobileUserAgent && window.innerWidth > breakpoint) {
                hideButtons('.fa-share-alt');
                showButtons('.share-buttons');
                showButtons('.share-buttons-text');
            }
        });

        footerShare.addEventListener('mouseleave', () => {
            if (!isMobileUserAgent) {
                if (window.innerWidth > breakpoint) {
                    showButtons('.fa-share-alt');
                    hideButtons('.share-buttons');
                    hideButtons('.share-buttons-text');
                } else {
                    showButtons('.share-buttons');
                    hideButtons('.fa-share-alt');
                    hideButtons('.share-buttons-text');
                }
            }
        });
    }
}

function resetButtons(breakpoint: number): void {
    const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (!isMobileUserAgent) {
        hideButtons('.share-button-mobile');

        if (window.innerWidth > breakpoint) {
            showButtons('.fa-share-alt');
            hideButtons('.share-buttons');
            hideButtons('.share-buttons-text');
        } else {
            showButtons('.share-buttons');
            hideButtons('.fa-share-alt');
            hideButtons('.share-buttons-text');
        }
    }
}

function showButtons(selector: string): void {
    document.querySelectorAll(selector).forEach((el) => {
        el.classList.remove('hidden');
    });
}

function hideButtons(selector: string): void {
    document.querySelectorAll(selector).forEach((el) => {
        el.classList.add('hidden');
    });
}

export default function ShareButtons(): void {
    shareButtons();
}
